var _defs, _rect, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _polygon2, _path12, _path13, _path14, _rect2, _rect3, _rect4, _circle2, _circle3, _circle4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawTailwindCss1Egw2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 884.32978,
    height: 497.5726,
    viewBox: "0 0 884.32978 497.5726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0ba8c84-577a-4822-8dcd-01697aaa3f6e-33",
    x1: 3.36222,
    y1: 897.41596,
    x2: 4.02186,
    y2: 897.18777,
    gradientTransform: "matrix(256, 0, 0, -153.60001, -255, 138394.6055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2298bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ed7b5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tailwind_css") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 837.32978,
    y: 467.78825,
    width: 47,
    height: 2,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M898.00948,643.47343c0,29.37842,21.86088,27.78808,48.82763,27.78808s48.82763,1.59034,48.82763-27.78808-21.86087-78.60057-48.82763-78.60057S898.00948,614.095,898.00948,643.47343Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783.1868,400.87659c.02614-.08308.05372-.16722.08-.25058-.01134.03654-.02558.07168-.0367.10833Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "715.66 395.323 732.333 411.202 745.83 396.911 725.188 386.589 715.66 395.323",
    fill: "#ffb9b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M894.98267,599.67353s-20.19865-1.31957-17.83761,4.57685-2.64377,27.57073-2.64377,27.57073-7.50492,38.92475,16.226,23.4358,18.56691-26.24962,18.56691-26.24962,6.9255-10.47017,5.44985-14.15544-13.20271-17.83784-15.44986-16.06616A4.42657,4.42657,0,0,1,894.98267,599.67353Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M902.07767,533.81483s-88.92186-7.14551-96.06736,11.11523,7.1455,31.75781,7.1455,31.75781l57.958,28.582,18.48552-16.53619-10.54607-9.664s59.54589,11.11524,61.13378,2.38184S933.83548,526.66932,902.07767,533.81483Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M798.8648,549.69373s-15.8789,44.46093,0,42.0791,14.291-38.10937,14.291-38.10937Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M834.19536,458.787s-9.92432,5.16064-8.33643,11.51221-6.35156,46.04882-6.35156,46.04882L795.689,551.28162l19.84863,7.14551s25.40624-16.67285,29.376-28.582,9.52734-30.16991,9.52734-30.16991Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 681.52074,
    cy: 212.71541,
    r: 26.20019,
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M837.37114,432.58682s3.17578,26.20019,1.58789,36.52148,31.75781-37.31543,31.75781-37.31543-14.291-10.32128-14.291-14.291S837.37114,432.58682,837.37114,432.58682Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M807.654,403.85045a30.595,30.595,0,0,1,7.66.053,10.2982,10.2982,0,0,1,6.54644,3.65872c1.812,2.426,2.41428,6.11091,5.25368,7.16284,1.692.62686,3.65113.03035,5.3443.65413,2.03262.74884,3.06482,2.9961,3.60547,5.09371s-.146,1.36927,1.23793,3.03569,6.35557-.44743,6.88014-2.30033a5.81667,5.81667,0,0,1,3.6687-4.14c3.12-.90364,6.02434,1.80716,8.12526,4.28449s4.91457,5.24,8.06892,4.46472c3.31005-.81361,4.43968-4.88569,4.80419-8.27472.83043-7.72093.70735-15.91946-3.02675-22.72819-5.40437-9.85428-17.74065-14.63671-28.87289-13.0916s-20.95812,8.49434-28.13952,17.13966a9.94072,9.94072,0,0,0-2.56673,4.75886",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M841.34087,463.55068l8.73339-8.7334,15.085-30.16991,40.4912,12.70312s14.291,3.96973,23.02441,29.376c0,0,52.40039,67.48534,43.667,78.60057s-10.32129,10.32129-24.6123,1.58789a126.62993,126.62993,0,0,0-28.582-12.70312l-38.10937,3.96973-23.02441-28.582s-34.13964-22.23046-28.582-47.63671l9.52734-12.70312Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M847.29545,543.34217l-4.76367,3.17578s-26.20019,32.55175-13.49706,38.90332S854.441,553.66346,854.441,553.66346Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#ffb9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M883.29862,438.232a6.81782,6.81782,0,0,0-4.86075,2.59753c-3.15014,4.008-7.845,13.43391-.9725,29.46973a256.378,256.378,0,0,1,13.49707,39.69725s-3.96973-.79394-3.96973,2.38184,3.17578,1.58789,0,3.17578-2.38183-.79395-3.17578,1.58789c-.82919,2.48758.07363,2.37714-1.81382,3.28651a15.33,15.33,0,0,0-4.85039,4.21736,5.604,5.604,0,0,1-1.27524,1.22953l-29.376,15.085s-3.96973,15.8789,7.93945,15.8789c0,0,73.043-20.64258,71.45507-36.52148C924.3436,504.79349,921.27341,435.38885,883.29862,438.232Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "741.067 437.402 741.067 458.044 763.297 456.457 758.533 435.814 741.067 437.402",
    fill: "#ffb9b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M914.78079,648.14293s-18.26073-8.73339-18.26073-2.38183-12.70313,24.6123-12.70313,24.6123-21.43652,33.3457,6.35156,27.78808,26.99414-17.46679,26.99414-17.46679,10.32129-7.14551,10.32129-11.11524-5.62582-21.46742-8.37053-20.658A4.42658,4.42658,0,0,1,914.78079,648.14293Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M937.01126,535.40272s-56.37011-12.70312-53.98827,7.93945,4.76367,32.55175,4.76367,32.55175l9.52734,67.48534,22.23047-2.38183,1.58789-12.70313s4.76367-4.76367,2.38183-7.93945,3.96973-34.13964,3.96973-34.13964,38.10937,7.93945,41.28515-15.085-4.76368-30.16991-4.76368-30.16991Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.55869,645.23669c3.98581,12.061-4.177,25.60377-4.177,25.60377s-14.62509-6.012-18.61091-18.073,4.177-25.60376,4.177-25.60376S1024.57287,633.17568,1028.55869,645.23669Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "#f50057"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.24671,
    y: 0.32756,
    width: 577.80627,
    height: 370.05284,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.76895,
    y: 46.74142,
    width: 544.7618,
    height: 301.74663,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 577.80627,
    height: 24.54733,
    fill: "#f50057"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2416,
    cy: 12.54989,
    r: 4.54966,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.51096,
    cy: 12.54989,
    r: 4.54966,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.78033,
    cy: 12.54989,
    r: 4.54966,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 313.61884,
    y: 112.24968,
    width: 203.96777,
    height: 22,
    fill: "#f50057"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 313.61884,
    y: 173.32487,
    width: 203.96777,
    height: 11,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 313.61884,
    y: 206.89958,
    width: 203.96777,
    height: 11,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 313.61884,
    y: 240.89958,
    width: 203.96777,
    height: 11,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.47931,
    y: 101.78836,
    width: 179.24636,
    height: 179.24636,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 298.8884,
    y: 265.92984,
    width: 3.99957,
    height: 253.14423,
    transform: "translate(-347.24794 126.50754) rotate(-45)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 174.31607,
    y: 390.50217,
    width: 253.14423,
    height: 3.99957,
    transform: "translate(-347.24794 126.50754) rotate(-45)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 425.23344,
    y: 259.44878,
    width: 218.43463,
    height: 225.26071,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M692.31311,520.18949q-32.86044,0-41.07555,32.86045,12.32266-16.43022,28.75289-12.32267c6.24957,1.56239,10.71646,6.09622,15.66074,11.115,8.05446,8.17555,17.37648,17.63784,37.73748,17.63784q32.86046,0,41.07556-32.86045-12.32267,16.43023-28.75289,12.32267c-6.24957-1.56239-10.71646-6.09622-15.66074-11.115C721.99613,529.65178,712.67412,520.18949,692.31311,520.18949Zm-41.07555,49.29067q-32.86045,0-41.07556,32.86045,12.32266-16.43022,28.75289-12.32267c6.24957,1.56239,10.71646,6.09622,15.66074,11.115,8.05446,8.17555,17.37648,17.63784,37.73748,17.63784q32.86046,0,41.07556-32.86045-12.32267,16.43024-28.75289,12.32267c-6.24956-1.56239-10.71646-6.09622-15.66074-11.115C680.92058,578.94245,671.59856,569.48016,651.23756,569.48016Z",
    transform: "translate(-157.83526 -201.2137)",
    fill: "url(#b0ba8c84-577a-4822-8dcd-01697aaa3f6e-33)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTailwindCss1Egw2);
export default __webpack_public_path__ + "static/media/undraw_tailwind_css_1egw (2).3e87984920803e3f720d3acb287510d7.svg";
export { ForwardRef as ReactComponent };